var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.5H10M6 14.5V11.1667M6 14.5H2.6C2.26863 14.5 2 14.2314 2 13.9V11.7667C2 11.4353 2.26863 11.1667 2.6 11.1667H6M10 14.5V6.5M10 14.5H13.4C13.7314 14.5 14 14.2314 14 13.9V3.1C14 2.76863 13.7314 2.5 13.4 2.5H10.6C10.2686 2.5 10 2.76863 10 3.1V6.5M10 6.5H6.6C6.26863 6.5 6 6.76863 6 7.1V11.1667",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.ddc5e75d7d663490027592f096cae82e.svg";
export { ForwardRef as ReactComponent };